import { getContentfulClient } from "../../../lib/contentful/contentfulClient"
import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { ICarrotPlanMenuItem } from "../../../contentful-types"
import { HttpStatusCodes } from "../../../utils/HttpStatusCodes"
import ResponseError from "../../../types/responseError"

const CACHE_KEY = "CarrotPlanMenuItems"

export type MenuItem = {
  entityId: string
  displayText: string
  defaultUrl: string
}

const client = getContentfulClient()

const loadStepDisplayData = async (stepList): Promise<MenuItem[]> => {
  const { items } = await client.getEntries({
    content_type: "carrotPlanMenuItem",
    "sys.id[in]": stepList
  })
  const planMenuItems = items as ICarrotPlanMenuItem[]

  return planMenuItems.map((item) => {
    if (!item.fields) {
      return null
    }
    const {
      sys: { id },
      fields: { displayText, defaultUrl }
    } = item
    if (!displayText || !id) {
      return null
    }
    return {
      entityId: id,
      displayText,
      defaultUrl
    }
  })
}

export default function useCarrotPlanMenuItems(steps): UseQueryResult<MenuItem[], ResponseError> {
  const stepList = steps.map(({ menuItemId }) => menuItemId).join(",")
  return useQuery<MenuItem[], ResponseError>([CACHE_KEY, stepList], () => loadStepDisplayData(stepList), {
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      switch (error.statusCode) {
        case HttpStatusCodes.UNAUTHORIZED:
        case HttpStatusCodes.BAD_REQUEST:
        case HttpStatusCodes.NOT_FOUND:
          return false
        default:
          return failureCount <= 3
      }
    }
  })
}
